<script setup lang="ts">
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
import PlaceLeaveFeedback from "../PlaceReviews/PlaceLeaveFeedback.vue";
import { useUserStore } from "@/modules/user-module";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["showReviews", "ratePlace"]);
const { t } = useI18n();
const placeStore = usePlaceStore();
const reviewsMeta = computed(() => placeStore.place?.reviews_meta);
const userStore = useUserStore();
const user = computed(() => userStore.user);
</script>

<template>
  <section class="reviews-preview">
    <div v-if="!user || !reviewsMeta?.is_visited" class="place-stats">
      <img src="@/assets/images/rating-empty.svg" alt="" />
      <p v-if="!user">
        <strong>{{ t("place.reviews.reviewImportant") }}</strong>
        {{ t("place.reviews.auth") }}
      </p>
      <p v-else>
        <strong>{{ t("place.reviews.reviewImportant") }}</strong>
        {{ t("place.reviews.reviewVisit") }}
      </p>
    </div>

    <PlaceLeaveFeedback
      v-else
      :reviews-meta="reviewsMeta"
      @ratePlace="emit('ratePlace', $event)"
    />
  </section>
</template>

<style scoped lang="scss">
.reviews-preview {
  padding: calc($base-space * 6) ($base-space * 8);
  border-top: 1px solid var(--color-semantic-border-normal-soft);

  @media (max-width: 1023px) {
    padding: calc($base-space * 6);
  }

  @media (max-width: 767px) {
    padding: calc($base-space * 5) calc($base-space * 4);
  }

  > .place-stats {
    margin: calc($base-space * 4) 0 0;

    @media (max-width: 1023px) {
      margin: calc($base-space * 3) 0 0;
    }
  }

  > button {
    margin: calc($base-space * 6) 0 0;
    width: 100%;

    @media (max-width: 767px) {
      margin: calc($base-space * 4) 0 0;
    }
  }
}

.place-stats {
  border-radius: 12px;
  background-color: var(--color-semantic-background-normal-secondary);
  padding: calc($base-space * 4);
  background: var(--color-non-semantic-background-soft-yellow);
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: center;
  gap: calc($base-space * 4);

  > p {
    @include body-s();
    color: var(--color-semantic-content-normal-secondary);
  }
}
</style>
